/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_EnableInputs */



/**
* | output |
* | --- |
* | "Enable" |
*
* @param {Notifications_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_enable = /** @type {((inputs?: Notifications_EnableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_EnableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ativar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva")
	return /** @type {LocalizedString} */ ("Enable")
});